import React from "react";
import { Button, Container, Image } from "react-bootstrap";
import cta from "../../../../Asset/life@wo-cta.webp";
import "./Last.css";
import { useNavigate } from "react-router-dom";

const Last = () => {
  const navigate = useNavigate();

  const hendleClick = () => {
    navigate("/ContactUs");
  };
  return (
    <>
      <section className="last-sec-lifeat">
        <Container>
          <div className="row sec-4-row">
            <div className="col-xl-8 col-md-8 cta-content">
              <div className="sec-4-cta-card">
                <h4>Have an Idea to do something that can make an Impact?</h4>
                <h3>We’re made for each other.</h3>
                <Button onClick={hendleClick} className="btn btn-primary">
                  Share Your Ideas{" "}
                </Button>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 cta-img">
              <div className="cta-bg">
                <Image src={cta} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Last;
